module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "padded"
  }, [_c('h2', [_c('i', {
    staticClass: "fa fa-sitemap"
  }), _vm._v(" Structure Report"), (_vm.isTowerCo()) ? _c('small', [_c('check-box', {
    attrs: {
      "no-form": ""
    },
    on: {
      "change": _vm.getData
    },
    model: {
      value: (_vm.sup),
      callback: function($$v) {
        _vm.sup = $$v
      },
      expression: "sup"
    }
  }, [_vm._v("View Suppliers")])], 1) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "type": "border-card",
      "stretch": ""
    }
  }, _vm._l((_vm.list), function(l, i) {
    return _c('el-tab-pane', {
      key: l.status,
      attrs: {
        "label": l.status,
        "lazy": ""
      }
    }, [_c('el-row', [_c('el-col', {
      attrs: {
        "sm": 24,
        "md": 12
      }
    }, [_c('good-table', {
      attrs: {
        "cols": _vm.cols,
        "rows": l.data,
        "striped": "",
        "theme": "polar-bear"
      }
    })], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "sm": 24,
        "md": 12
      }
    }, [_c('pie-chart', {
      attrs: {
        "data": _vm.chart[i].data,
        "donut": true,
        "thousands": ",",
        "legend": "",
        "colors": _vm.colors
      }
    })], 1)], 1)], 1)
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21d097e4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/sites/StructureReport.vue
// module id = 1365
// module chunks = 0